
import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { Param } from "@/lib/model/exambuilder/exam-v2";
@Component({
  components: {}
})
export default class MyCollapse extends Vue {
  @Prop({ type: Array, default: [] }) options!: Param[];
  @Prop({ type: Array, default: [] }) valueList!: Param[];
  @Prop({ type: String, default: "" }) id!: string;
  @Prop({ type: Number, default: 0 }) livenessRecognition!: number;
  collapseInd = 0;

  mounted() {
    window.addEventListener("click", e => {
      const element: any = document.getElementById(this.id);
      // 兼容火狐方法
      // console.log(
      //   element.compareDocumentPosition(e.target),
      //   "aaaaaaaaaaaaaaaa"
      // );
      if (
        element &&
        element.compareDocumentPosition &&
        element.compareDocumentPosition(e.target) !== 20
      ) {
        this.collapseInd = 0;
      }
    });
  }
  @Emit("edit")
  editRegis(item: Param) {
    return item;
  }
  @Emit("select")
  select(item: Param) {
    return item;
  }
  doClickItem(e: any) {
    console.log(e);
  }
}
